import BrowserFrame from "./BrowserFrame";
import PhoneFrame from "./PhoneFrame";

const HERO_MAIN_IMG = "/assets/hero-main.jpg";

const HERO_PHONE_IMG = "/assets/hero-phone.jpg";

export default function Hero() {
  return (
    <section id="top" className="scroll-mt-20 bg-cream">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_1fr] lg:gap-10">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-bold text-navy-700">
              <span className="h-px w-6 bg-lime-400" aria-hidden="true" />
              新規事業・期間限定プロジェクト・イベントに
            </p>

            <h1 className="mt-6 font-heading text-4xl font-black leading-[1.15] tracking-tight text-navy-950 sm:text-5xl lg:text-6xl">
              事業は決まった。
              <br />
              ホームページが、
              <br />
              <span className="inline-block whitespace-nowrap bg-lime-400 px-2">まだない。</span>
            </h1>

            <p className="mt-7 max-w-md text-base leading-relaxed text-navy-600 md:text-lg">
              新規事業・期間限定プロジェクト・イベントに。
              <br />
              忙しい担当者に代わって、情報整理からサイト公開までサポートします。
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-lime-400 px-6 py-3.5 text-base font-bold text-navy-950 transition-colors hover:bg-lime-500"
              >
                公開日について相談する
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
              <a
                href="#examples"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-navy-200 px-6 py-3.5 text-base font-bold text-navy-800 transition-colors hover:border-navy-900"
              >
                制作イメージを見る
              </a>
            </div>
          </div>

          <div className="relative">
            <BrowserFrame className="shadow-2xl shadow-navy-950/10">
              <div className="relative">
                <img
                  src={HERO_MAIN_IMG}
                  alt="新しいサービス紹介サイトの画面見本。温かみのあるワークスペースの写真"
                  title="制作イメージ：事業紹介サイト"
                  className="h-52 w-full object-cover md:h-64"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950/80 via-navy-900/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <span className="inline-flex rounded-full bg-lime-400 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-navy-950">
                    New Service
                  </span>
                  <p className="mt-2 font-heading text-xl font-black text-white md:text-2xl">
                    新しい事業を、はじめよう。
                  </p>
                  <span className="mt-3 inline-block rounded-md bg-white px-3 py-1.5 text-xs font-bold text-navy-900">
                    お問い合わせ
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2 bg-white p-4">
                {["事業概要", "サービス", "会社情報"].map((label) => (
                  <div key={label} className="flex items-center gap-2 rounded-md bg-navy-50 px-2.5 py-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-lime-500" aria-hidden="true" />
                    <span className="text-[11px] font-medium text-navy-700">{label}</span>
                  </div>
                ))}
              </div>
            </BrowserFrame>

            <PhoneFrame className="absolute -bottom-6 -right-3 w-28 sm:-right-6 sm:w-32">
              <img
                src={HERO_PHONE_IMG}
                alt="スマートフォン向けサイトの画面見本"
                title="制作イメージ：スマートフォン表示"
                className="h-52 w-full object-cover sm:h-60"
              />
            </PhoneFrame>
          </div>
        </div>
      </div>
    </section>
  );
}
